import { createGlobalStyle } from "styled-components";

/* These feed px-valued type and chrome sizes. Reading the physical screen meant a
   phone resolved them against ~390, collapsing body text to ~4px; reading a clamped
   viewport keeps a full-width desktop identical while staying legible on a phone. */
const REFERENCE_WIDTH = Math.min(Math.max(window.innerWidth, 1200), 1920);
const REFERENCE_HEIGHT = Math.min(Math.max(window.innerHeight, 700), 1200);

export const PROJECT_THEME = {
    BORDER_RADIUS: '4px',
    colour: {
        LIGHT_GREY: '#606068',
        DARK_GREY: '#17171A',
        OFF_WHITE: '#E8E8E8',
        COLOUR_LIGHT: '#FFA600',
        COLOUR_MID_LIGHT: '#FF6361',
        COLOUR_MID: '#BC5090',
        COLOUR_MID_DARK: '#58508D',
        COLOUR_DARK: '#003F5C',
        PALETTE: [
            '#FFA600',
            '#FF6361',
            '#BC5090',
            '#58508D',
            '#003F5C'
        ]
    }, 
    dimensions: {
        NAVBAR_HEIGHT: REFERENCE_HEIGHT * 0.08,
        NAVBAR_PADDING: REFERENCE_WIDTH * 0.025,
        FONT_SIZE_LARGE: REFERENCE_WIDTH * 0.03,
        FONT_SIZE_MEDIUM: REFERENCE_WIDTH * 0.015,
        FONT_SIZE_SMALL: REFERENCE_WIDTH * 0.01,
    },
    font: {
        FONT_SERIF_ROBOTO_SLAB: '"Roboto Slab", serif',
        FONT_SERIF_ROBOTO_SERIF: '"Roboto Serif", serif',
        FONT_MONO_JETBRAINS: '"JetBrains Mono", monospace',
        FONT_SANS_RED_HAT_DISPLAY: '"Red Hat Display", sans-serif',
    }
}

type ProjectThemeType = typeof PROJECT_THEME;

declare module 'styled-components' {
    export interface DefaultTheme extends ProjectThemeType {}
}
